// import React from "react";

import { useQuery } from "@apollo/client";

import gql from "graphql-tag";

const PANEL_QUERY = gql`
  {
    panelSelect @client {
      panelId
    }
  }
`;

export default function usePanel(panelId?: any) {
  const { data /*, error, loading*/ } = useQuery(PANEL_QUERY); // TODO as props?
  // return panelId && panelId > 0
  //   ? panelId
  //   : data.panelSelect.panelId
  return panelId ? panelId : data.panelSelect.panelId;
}
